var _path, _line;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "17 0 65 100",
    enableBackground: "new 0 0 100 100",
    width: "45px",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#f1a852",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M35.97,13.933c2.077-1.201,0.759-4.024,7.454-4.043  c4.703-0.012,6.624,3.93,6.696,8.466c0.127,7.958-1.447,5.475-5.054,6.833c-3.664,1.378-0.227,7.047,0.759,8.763  c4.016,6.999,2.273-2.584,4.167-4.101c1.896-1.516,7.796-0.698,11.838,4.861c2.816,3.871,1.581,15.221,3.325,31.273  c1.17,10.791-7.834,2.214-15.795-12.636C47.22,49.356,38.91,33.344,39.128,26.062c0.126-4.211,5.181-2.915,6.064-6.316  c0.955-3.672-4.934-3.617-6.064-3.663c-3.032-0.127-7.848,1.543-14.666,2.909C22.352,19.415,33.601,15.308,35.97,13.933z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#f1a852",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    x1: 55.119,
    y1: 62.776,
    x2: 55.119,
    y2: 91.632
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.aedb9d3ce17da0bc0da003e97c2cc16c.svg";
export { ForwardRef as ReactComponent };